import { createFileRoute } from '@tanstack/react-router'
import PrinterPriceImport from 'Administration/components/import/printerprice/PrinterPriceImport'

import AdministrationPage from '../-administrationPage'
import { Guard } from '../-guard'

export const Route = createFileRoute('/administration/printerprices')({
    component: () => (
        <Guard claims={['opus_user']}>
            <AdministrationPage>
                <PrinterPriceImport />
            </AdministrationPage>
        </Guard>
    ),
})
